<script setup lang="ts">
import { ref, watch, watchEffect } from "vue";
import CSSAnimation from "../base/CSSAnimation.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { CSSAnimation }
});

const props = withDefaults(
  defineProps<{
    status?: "wait" | "processing" | "success" | "error";
    color?: string;
  }>(),
  {
    status: "processing"
  }
);

const emits = defineEmits<{
  // (event: "change", value: boolean): void;
}>();

const p = ref();

watch(
  () => p.value,
  () => {
    p.value?.trigger();
  }
);

let color = ref("");
watchEffect(() => {
  switch (props.status) {
    case "wait":
      color.value = "#d9d9d9";
      break;
    case "success":
      color.value = "#52c41a";
      break;
    case "error":
      color.value = "#ff4d4f";
      break;
    case "processing":
    default:
      color.value = "#1677ff";
      break;
  }
  if (props.color) {
    color.value = props.color;
  }
});

defineExpose({});
</script>

<template>
  <div
    class="status"
    :style="{
      position: 'relative',
      display: 'inline-block',
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      overflow: 'hidden'
    }"
  >
    <CSSAnimation
      v-if="status === 'processing'"
      ref="p"
      name="statusProcessing"
      :style="{
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        backgroundColor: color
      }"
    ></CSSAnimation>
    <div
      :style="{
        position: 'absolute',
        top: '3px',
        left: '3px',
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        backgroundColor: color
      }"
    ></div>
  </div>
</template>
